import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// One-shot cleanup of the Dexie-backed offline cache from the previous
// architecture. deleteDatabase is a no-op when the DB doesn't exist, so this
// stays safe across reloads after the offline era is long gone.
if (typeof indexedDB !== 'undefined') {
  indexedDB.deleteDatabase('ViTailsDB');
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
